const textDefaults = {
	EN: {
		title: "Let's take a selfie",
		reason:
			'We need to take a picture to validate your identity. Please position your face in the center and click to capture.',
		getStarted: 'Take a selfie',
		back: 'Back',
		capture: 'Take photo',
		confirm: 'Confirm',
		retry: 'Retry',
		takeNewPicture: 'Take new picture',
		camInit: 'Initializing camera',
		camFaceInit: 'Initializing face algorithms',
		camMultipleFaces: 'More than one face was detected. Make sure you are alone in the frame, then take a new picture.',
		camNoFace:
			'No face was detected. Ensure your face is clearly visible, facing the camera, and well lit, then try again.',
		camFaceTooSmall:
			'Your face appears too small. Move closer to the camera so your face fills more of the frame, then take a new picture.',
		camFaceTooLarge:
			'Your face is too close to the camera. Move back a little so your full face fits in the frame, then take a new picture.',
		camEyesClosed: 'Your eyes appear to be closed. Please take a new picture with your eyes open and clearly visible.',
		camPoseInvalid:
			'Please look directly at the camera. Keep your head straight—do not tilt or turn it—and take a new picture.',
		camFaceNotCentered:
			'Your face needs to be centered in the frame. Position yourself so your face is in the middle of the square, then take a new picture.',
		camHint: 'Center your face and look into the camera',
		camHoldIt: 'Hold it!',
		evaluating: 'Evaluating your picture...',
		successMessage: 'Your picture looks good. You can continue below.',
		retryMessage:
			'The picture does not meet our requirements. Please take a new picture following the guidelines above to continue.',
		error:
			'Something went wrong while processing your picture. Please try again. If the problem persists, check your connection.',
	},
	FR: {
		title: 'Prenez un selfie',
		back: 'Retour',
		capture: 'Prendre la photo',
		reason:
			'Nous devons prendre une photo pour valider votre identité. Ce processus est entièrement automatique et la page suivante vous expliquera quoi faire.',
		getStarted: 'Prendre un selfie',
		confirm: 'Confirmer',
		retry: 'Réessayer',
		takeNewPicture: 'Reprendre une photo',
		camInit: 'Initialisation de la caméra',
		camFaceInit: 'Initialisation des algorithmes de reconnaissance faciale',
		camMultipleFaces:
			"Plus d'un visage a été détecté. Assurez-vous d'être seul dans le cadre, puis reprenez une photo.",
		camNoFace:
			'Aucun visage détecté. Assurez-vous que votre visage est bien visible, face à la caméra et correctement éclairé, puis réessayez.',
		camFaceTooSmall:
			'Votre visage paraît trop petit. Rapprochez-vous de la caméra pour mieux remplir le cadre, puis reprenez une photo.',
		camFaceTooLarge:
			'Vous êtes trop près de la caméra. Éloignez-vous légèrement pour que tout votre visage soit dans le cadre, puis reprenez une photo.',
		camEyesClosed: 'Vos yeux semblent fermés. Veuillez reprendre une photo avec les yeux ouverts et bien visibles.',
		camPoseInvalid:
			"Regardez directement la caméra. Gardez la tête droite, sans l'incliner ni la tourner, puis reprenez une photo.",
		camFaceNotCentered:
			'Votre visage doit être centré dans le cadre. Positionnez-vous au centre du carré, puis reprenez une photo.',
		camHint: 'Centrez votre visage et regardez dans la caméra',
		camHoldIt: 'Maintenez-le!',
		evaluating: 'Évaluation de votre photo...',
		successMessage: 'Votre photo est correcte. Vous pouvez continuer ci-dessous.',
		retryMessage:
			'La photo ne répond pas à nos critères. Veuillez reprendre une photo en suivant les recommandations ci-dessus.',
		error:
			"Une erreur s'est produite lors du traitement de votre photo. Veuillez réessayer. Si le problème persiste, vérifiez votre connexion.",
	},
	NL: {
		title: 'Laten we een selfie maken',
		back: 'Terug',
		capture: 'Foto maken',
		reason:
			'We moeten een foto nemen om uw identiteit te valideren. Dit proces is volledig automatisch en de volgende pagina legt uit wat u moet doen.',
		getStarted: 'Maak een selfie',
		confirm: 'Bevestigen',
		retry: 'Opnieuw proberen',
		takeNewPicture: 'Nieuwe foto maken',
		camInit: 'Camera initialiseren',
		camFaceInit: 'Gezichtsalgoritmen initialiseren',
		camMultipleFaces:
			'Er is meer dan één gezicht gedetecteerd. Zorg dat u alleen in beeld bent en maak een nieuwe foto.',
		camNoFace:
			'Geen gezicht gedetecteerd. Zorg dat uw gezicht duidelijk zichtbaar is, recht in de camera kijkt en goed verlicht is, en probeer het opnieuw.',
		camFaceTooSmall:
			'Uw gezicht lijkt te klein. Kom dichter bij de camera zodat uw gezicht meer van het beeld vult, en maak een nieuwe foto.',
		camFaceTooLarge:
			'U bent te dicht bij de camera. Ga iets verder terug zodat uw volledige gezicht in beeld past, en maak een nieuwe foto.',
		camEyesClosed: 'Uw ogen lijken gesloten te zijn. Maak een nieuwe foto met uw ogen open en duidelijk zichtbaar.',
		camPoseInvalid: 'Kijk recht in de camera. Houd uw hoofd recht—niet gekanteld of gedraaid—en maak een nieuwe foto.',
		camFaceNotCentered:
			'Uw gezicht moet gecentreerd zijn in het beeld. Positieer uzelf in het midden van het vierkant en maak een nieuwe foto.',
		camHint: 'Centreer uw gezicht en kijk in de camera',
		camHoldIt: 'Vasthouden!',
		evaluating: 'Uw foto wordt geëvalueerd...',
		successMessage: 'Uw foto ziet er goed uit. U kunt hieronder doorgaan.',
		retryMessage:
			'De foto voldoet niet aan onze eisen. Maak een nieuwe foto volgens de richtlijnen hierboven om door te gaan.',
		error:
			'Er is iets misgegaan bij het verwerken van uw foto. Probeer het opnieuw. Als het probleem aanhoudt, controleer uw verbinding.',
	},
	DE: {
		title: 'Machen Sie ein Selfie',
		back: 'Zurück',
		capture: 'Foto aufnehmen',
		reason:
			'Wir müssen ein Foto machen, um Ihre Identität zu bestätigen. Dieser Vorgang ist vollautomatisch, und auf der nächsten Seite wird erklärt, was zu tun ist.',
		getStarted: 'Selfie machen',
		confirm: 'Bestätigen',
		retry: 'Wiederholen',
		takeNewPicture: 'Neues Foto aufnehmen',
		camInit: 'Kamera wird initialisiert',
		camFaceInit: 'Gesichtsalgorithmen werden initialisiert',
		camMultipleFaces:
			'Es wurde mehr als ein Gesicht erkannt. Stellen Sie sicher, dass Sie allein im Bild sind, und machen Sie ein neues Foto.',
		camNoFace:
			'Kein Gesicht erkannt. Sorgen Sie dafür, dass Ihr Gesicht gut sichtbar ist, die Kamera anblickt und ausgeleuchtet ist, und versuchen Sie es erneut.',
		camFaceTooSmall:
			'Ihr Gesicht erscheint zu klein. Rücken Sie näher an die Kamera, damit Ihr Gesicht mehr vom Bild ausfüllt, und machen Sie ein neues Foto.',
		camFaceTooLarge:
			'Sie sind zu nah an der Kamera. Gehen Sie etwas weiter zurück, damit Ihr ganzes Gesicht ins Bild passt, und machen Sie ein neues Foto.',
		camEyesClosed:
			'Ihre Augen scheinen geschlossen zu sein. Bitte machen Sie ein neues Foto mit geöffneten und gut sichtbaren Augen.',
		camPoseInvalid:
			'Blicken Sie direkt in die Kamera. Halten Sie Ihren Kopf gerade—nicht geneigt oder gedreht—und machen Sie ein neues Foto.',
		camFaceNotCentered:
			'Ihr Gesicht muss zentriert sein. Positionieren Sie sich in der Mitte des Rahmens und machen Sie ein neues Foto.',
		camHint: 'Zentrieren Sie Ihr Gesicht und schauen Sie in die Kamera',
		camHoldIt: 'Halten Sie durch!',
		evaluating: 'Ihr Foto wird ausgewertet...',
		successMessage: 'Ihr Foto sieht gut aus. Sie können unten fortfahren.',
		retryMessage:
			'Das Bild erfüllt nicht unsere Anforderungen. Bitte machen Sie ein neues Foto gemäß den oben genannten Hinweisen.',
		error:
			'Bei der Verarbeitung Ihres Fotos ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Bei anhaltenden Problemen prüfen Sie Ihre Verbindung.',
	},
	PL: {
		title: 'Zróbmy sobie selfie',
		back: 'Wstecz',
		capture: 'Zrób zdjęcie',
		reason:
			'Musimy zrobić zdjęcie, aby potwierdzić Twoją tożsamość. Ten proces jest w pełni automatyczny, a następna strona wyjaśni, co zrobić.',
		getStarted: 'Zrób selfie',
		confirm: 'Potwierdź',
		retry: 'Ponów',
		takeNewPicture: 'Zrób nowe zdjęcie',
		successMessage: 'Twoje zdjęcie wygląda dobrze. Możesz kontynuować poniżej.',
		camInit: 'Inicjowanie kamery',
		camFaceInit: 'Inicjowanie algorytmów rozpoznawania twarzy',
		camMultipleFaces: 'Wykryto więcej niż jedną twarz. Upewnij się, że jesteś sam w kadrze, i zrób nowe zdjęcie.',
		camNoFace:
			'Nie wykryto twarzy. Upewnij się, że Twoja twarz jest dobrze widoczna, zwrócona w stronę kamery i oświetlona, a następnie spróbuj ponownie.',
		camFaceTooSmall:
			'Twoja twarz wygląda na zbyt małą. Podejdź bliżej do kamery, aby Twarz wypełniała więcej kadru, i zrób nowe zdjęcie.',
		camFaceTooLarge:
			'Jesteś zbyt blisko kamery. Cofnij się nieco, aby cała Twoja twarz mieściła się w kadrze, i zrób nowe zdjęcie.',
		camEyesClosed: 'Wygląda na to, że masz zamknięte oczy. Zrób nowe zdjęcie z otwartymi i dobrze widocznymi oczami.',
		camPoseInvalid:
			'Patrz prosto w kamerę. Trzymaj głowę prosto—nie przechylaj jej ani nie obracaj—i zrób nowe zdjęcie.',
		camFaceNotCentered:
			'Twoja twarz musi być wycentrowana w kadrze. Ustaw się tak, aby Twoja twarz była na środku kwadratu, i zrób nowe zdjęcie.',
		camHint: 'Wycentruj swoją twarz i patrz w kamerę',
		camHoldIt: 'Trzymaj!',
		evaluating: 'Ocenianie zdjęcia...',
		retryMessage:
			'Zdjęcie nie spełnia naszych wymagań. Zrób nowe zdjęcie zgodnie z wytycznymi powyżej, aby kontynuować.',
		error:
			'Wystąpił błąd podczas przetwarzania zdjęcia. Spróbuj ponownie. Jeśli problem się powtarza, sprawdź połączenie.',
	},
	BG: {
		title: 'Нека направим селфи',
		back: 'Назад',
		capture: 'Направете снимка',
		reason:
			'Трябва да направим снимка, за да потвърдим самоличността ви. Този процес е напълно автоматичен и следващата страница ще обясни какво да направите.',
		getStarted: 'Направете селфи',
		confirm: 'Потвърди',
		retry: 'Нов опит',
		takeNewPicture: 'Направете нова снимка',
		successMessage: 'Снимката ви изглежда добре. Можете да продължите по-долу.',
		camInit: 'Инициализация на камерата',
		camFaceInit: 'Инициализация на алгоритми за разпознаване на лица',
		camMultipleFaces: 'Открито е повече от едно лице. Уверете се, че сте сами в кадра, и направете нова снимка.',
		camNoFace:
			'Не е открито лице. Уверете се, че лицето ви е добре видимо, обърнато към камерата и осветено, след което опитайте отново.',
		camFaceTooSmall:
			'Лицето ви изглежда твърде малко. Приближете се към камерата, за да запълните повече от кадра, и направете нова снимка.',
		camFaceTooLarge:
			'Сте твърде близо до камерата. Отдалечете се малко, за да се побере цялото ви лице в кадра, и направете нова снимка.',
		camEyesClosed: 'Изглежда, че очите ви са затворени. Моля, направете нова снимка с отворени и добре видими очи.',
		camPoseInvalid:
			'Моля, гледайте право в камерата. Дръжте главата си право—без да я накланяте или въртите—и направете нова снимка.',
		camFaceNotCentered:
			'Лицето ви трябва да е центрирано в кадра. Позиционирайте се така, че лицето ви да е в средата на квадрата, и направете нова снимка.',
		camHint: 'Центрирайте лицето си и гледайте в камерата',
		camHoldIt: 'Задръжте!',
		evaluating: 'Оценяване на снимката...',
		retryMessage:
			'Снимката не отговаря на нашите изисквания. Моля, направете нова снимка съгласно указанията по-горе, за да продължите.',
		error:
			'Възникна грешка при обработката на снимката ви. Моля, опитайте отново. Ако проблемът продължава, проверете връзката си.',
	},
	CS: {
		title: 'Udělejme si selfie',
		back: 'Zpět',
		capture: 'Pořídit fotografii',
		reason:
			'Musíme pořídit fotografii pro ověření vaší identity. Tento proces je plně automatický a následující stránka vysvětlí, co dělat.',
		getStarted: 'Udělat selfie',
		confirm: 'Potvrdit',
		retry: 'Zkusit znovu',
		takeNewPicture: 'Pořídit novou fotografii',
		successMessage: 'Váš obrázek vypadá dobře. Můžete pokračovat níže.',
		camInit: 'Inicializace kamery',
		camFaceInit: 'Inicializace algoritmů pro rozpoznávání obličeje',
		camMultipleFaces:
			'Bylo zjištěno více než jedno obličej. Ujistěte se, že jste sám v záběru, a poříďte novou fotografii.',
		camNoFace:
			'Nebyl zjištěn žádný obličej. Zajistěte, aby byl váš obličej jasně viditelný, otočený ke kameře a dobře osvětlený, a zkuste to znovu.',
		camFaceTooSmall:
			'Váš obličej se jeví příliš malý. Přistupte blíže ke kameře, aby váš obličej vyplňoval více záběru, a poříďte novou fotografii.',
		camFaceTooLarge:
			'Jste příliš blízko kamery. Ustupte trochu, aby se celý váš obličej vešel do záběru, a poříďte novou fotografii.',
		camEyesClosed:
			'Zdá se, že máte zavřené oči. Poříďte prosím novou fotografii s otevřenýma a jasně viditelnýma očima.',
		camPoseInvalid:
			'Podívejte se přímo do kamery. Držte hlavu rovně—ne nakloněnou ani otočenou—a poříďte novou fotografii.',
		camFaceNotCentered:
			'Váš obličej musí být v záběru vycentrovaný. Umístěte se tak, aby byl váš obličej uprostřed čtverce, a poříďte novou fotografii.',
		camHint: 'Zaměřte svůj obličej a podívejte se do kamery',
		camHoldIt: 'Zadržte!',
		evaluating: 'Vyhodnocování fotografie...',
		retryMessage:
			'Fotografie nesplňuje naše požadavky. Poříďte prosím novou fotografii podle výše uvedených pokynů pro pokračování.',
		error:
			'Při zpracování vaší fotografie došlo k chybě. Zkuste to prosím znovu. Pokud problém přetrvává, zkontrolujte své připojení.',
	},
	DA: {
		title: 'Lad os tage et selfie',
		back: 'Tilbage',
		capture: 'Tag billede',
		reason:
			'Vi skal tage et billede for at validere din identitet. Denne proces er fuldt automatisk og næste side vil forklare, hvad du skal gøre.',
		getStarted: 'Tag et selfie',
		confirm: 'Bekræft',
		retry: 'Prøv igen',
		takeNewPicture: 'Tag et nyt billede',
		successMessage: 'Dit billede ser godt ud. Du kan fortsætte nedenfor.',
		camInit: 'Initialiserer kamera',
		camFaceInit: 'Initialiserer ansigtsalgoritmer',
		camMultipleFaces:
			'Der blev opdaget mere end ét ansigt. Sørg for, at du er alene i billedet, og tag et nyt billede.',
		camNoFace:
			'Intet ansigt blev opdaget. Sørg for, at dit ansigt er tydeligt synligt, vender mod kameraet og er godt oplyst, og prøv igen.',
		camFaceTooSmall:
			'Dit ansigt virker for lille. Flyt dig tættere på kameraet, så dit ansigt fylder mere af billedet, og tag et nyt billede.',
		camFaceTooLarge:
			'Du er for tæt på kameraet. Træd lidt tilbage, så hele dit ansigt passer ind i billedet, og tag et nyt billede.',
		camEyesClosed:
			'Det ligner, at dine øjne er lukkede. Tag venligst et nyt billede med åbne og tydeligt synlige øjne.',
		camPoseInvalid:
			'Kig venligst direkte i kameraet. Hold dit hoved lige—uden at tippe eller vende det—og tag et nyt billede.',
		camFaceNotCentered:
			'Dit ansigt skal være centreret i billedet. Positioner dig, så dit ansigt er i midten af firkanten, og tag et nyt billede.',
		camHint: 'Centrer dit ansigt og kig ind i kameraet',
		camHoldIt: 'Hold det!',
		evaluating: 'Evaluerer dit billede...',
		retryMessage:
			'Billedet opfylder ikke vores krav. Tag venligst et nyt billede efter retningslinjerne ovenfor for at fortsætte.',
		error:
			'Der opstod en fejl under behandling af dit billede. Prøv venligst igen. Hvis problemet fortsætter, tjek din forbindelse.',
	},
	ES: {
		title: 'Hagamos un selfie',
		back: 'Atrás',
		capture: 'Tomar foto',
		reason:
			'Necesitamos tomar una foto para validar su identidad. Este proceso es totalmente automático y la siguiente página explicará qué hacer.',
		getStarted: 'Tomar un selfie',
		confirm: 'Confirmar',
		retry: 'Reintentar',
		takeNewPicture: 'Tomar nueva foto',
		successMessage: 'Tu foto se ve bien. Puedes continuar a continuación.',
		camInit: 'Inicializando cámara',
		camFaceInit: 'Inicializando algoritmos faciales',
		camMultipleFaces: 'Se detectó más de un rostro. Asegúrese de estar solo en el encuadre y tome una nueva foto.',
		camNoFace:
			'No se detectó ningún rostro. Asegúrese de que su rostro sea claramente visible, mire a la cámara y esté bien iluminado, luego intente de nuevo.',
		camFaceTooSmall:
			'Su rostro parece demasiado pequeño. Acérquese a la cámara para que su rostro ocupe más del encuadre y tome una nueva foto.',
		camFaceTooLarge:
			'Está demasiado cerca de la cámara. Aléjese un poco para que todo su rostro quepa en el encuadre y tome una nueva foto.',
		camEyesClosed:
			'Parece que tiene los ojos cerrados. Tome una nueva foto con los ojos abiertos y claramente visibles.',
		camPoseInvalid:
			'Mire directamente a la cámara. Mantenga la cabeza recta—sin inclinarla ni girarla—y tome una nueva foto.',
		camFaceNotCentered:
			'Su rostro debe estar centrado en el encuadre. Colóquese de modo que su rostro esté en el centro del cuadrado y tome una nueva foto.',
		camHint: 'Centre su rostro y mire a la cámara',
		camHoldIt: '¡Manténgalo!',
		evaluating: 'Evaluando su foto...',
		retryMessage:
			'La foto no cumple con nuestros requisitos. Tome una nueva foto siguiendo las directrices anteriores para continuar.',
		error:
			'Ocurrió un error al procesar su foto. Por favor intente de nuevo. Si el problema persiste, verifique su conexión.',
	},
	FI: {
		title: 'Otetaan selfie',
		back: 'Takaisin',
		capture: 'Ota kuva',
		reason:
			'Meidän on otettava valokuva henkilöllisyytesi vahvistamiseksi. Tämä prosessi on täysin automaattinen ja seuraava sivu selittää mitä tehdä.',
		getStarted: 'Ota selfie',
		confirm: 'Vahvista',
		retry: 'Yritä uudelleen',
		takeNewPicture: 'Ota uusi kuva',
		successMessage: 'Kuvasi näyttää hyvältä. Voit jatkaa alla.',
		camInit: 'Kameraa alustetaan',
		camFaceInit: 'Kasvoalgoritmeja alustetaan',
		camMultipleFaces: 'Havaittiin useampi kuin yksi kasvo. Varmista, että olet yksin kuvassa, ja ota uusi kuva.',
		camNoFace:
			'Kasvoja ei havaittu. Varmista, että kasvosi ovat selvästi näkyvissä, kameran suuntaan ja hyvin valaistu, ja yritä uudelleen.',
		camFaceTooSmall:
			'Kasvosi näyttävät liian pieneltä. Siirry lähemmäs kameraa, jotta kasvosi täyttävät enemmän kuvaa, ja ota uusi kuva.',
		camFaceTooLarge:
			'Olet liian lähellä kameraa. Siirry hieman taakse, jotta koko kasvosi mahtuvat kuvaan, ja ota uusi kuva.',
		camEyesClosed: 'Silmäsi vaikuttavat olevan kiinni. Ota uusi kuva silmät auki ja selvästi näkyvillä.',
		camPoseInvalid: 'Katso suoraan kameraan. Pidä pääsi suorana—älä kallista tai käännä sitä—ja ota uusi kuva.',
		camFaceNotCentered:
			'Kasvosi on keskittää kuvaan. Asenna itsesi niin, että kasvosi ovat neliön keskellä, ja ota uusi kuva.',
		camHint: 'Keskitä kasvosi ja katso kameraan',
		camHoldIt: 'Pidä kiinni!',
		evaluating: 'Arvioidaan kuvaa...',
		retryMessage: 'Kuva ei täytä vaatimuksiamme. Ota uusi kuva edellä olevien ohjeiden mukaisesti jatkaaksesi.',
		error: 'Kuvan käsittelyssä tapahtui virhe. Yritä uudelleen. Jos ongelma jatkuu, tarkista yhteytesi.',
	},
	HR: {
		title: 'Napravimo selfie',
		back: 'Natrag',
		capture: 'Snimi fotografiju',
		reason:
			'Moramo slikati kako bismo potvrdili vaš identitet. Ovaj proces je potpuno automatski i sljedeća stranica će objasniti što trebate napraviti.',
		getStarted: 'Napravite selfie',
		confirm: 'Potvrdi',
		retry: 'Pokušaj ponovno',
		takeNewPicture: 'Napravite novu fotografiju',
		successMessage: 'Vaša fotografija izgleda dobro. Možete nastaviti dolje.',
		camInit: 'Inicijalizacija kamere',
		camFaceInit: 'Inicijalizacija algoritama za prepoznavanje lica',
		camMultipleFaces:
			'Otkriveno je više od jednog lica. Pobrinite se da ste sami u kadru i napravite novu fotografiju.',
		camNoFace:
			'Nije otkriveno lice. Osigurajte da je vaše lice jasno vidljivo, okrenuto prema kameri i dobro osvijetljeno, zatim pokušajte ponovno.',
		camFaceTooSmall:
			'Vaše lice izgleda previše malo. Približite se kameri kako bi vaše lice ispunilo više kadra i napravite novu fotografiju.',
		camFaceTooLarge:
			'Preblizu ste kameri. Odmaknite se malo kako bi cijelo vaše lice stalo u kadar i napravite novu fotografiju.',
		camEyesClosed:
			'Čini se da su vam oči zatvorene. Molimo napravite novu fotografiju s otvorenim i jasno vidljivim očima.',
		camPoseInvalid:
			'Molimo pogledajte izravno u kameru. Držite glavu uspravno—bez naginjanja ili okretanja—i napravite novu fotografiju.',
		camFaceNotCentered:
			'Vaše lice mora biti centrirano u kadru. Postavite se tako da je vaše lice usred kvadrata i napravite novu fotografiju.',
		camHint: 'Centrirajte svoje lice i pogledajte u kameru',
		camHoldIt: 'Zadrži!',
		evaluating: 'Procjena fotografije...',
		retryMessage:
			'Fotografija ne ispunjava naše zahtjeve. Molimo napravite novu fotografiju prema gornjim smjernicama za nastavak.',
		error:
			'Došlo je do greške pri obradi vaše fotografije. Molimo pokušajte ponovno. Ako se problem nastavi, provjerite svoju vezu.',
	},
	HU: {
		title: 'Készítsünk egy selfie-t',
		back: 'Vissza',
		capture: 'Fénykép készítése',
		reason:
			'Fényképet kell készítenünk az Ön személyazonosságának ellenőrzéséhez. Ez a folyamat teljes mértékben automatizált, és a következő oldal elmagyarázza, mit kell tennie.',
		getStarted: 'Készítsen selfie-t',
		confirm: 'Megerősít',
		retry: 'Újra',
		takeNewPicture: 'Új fénykép készítése',
		successMessage: 'A fénykép jól néz ki. Az alább található gombbal folytathatja.',
		camInit: 'Kamera inicializálása',
		camFaceInit: 'Arc felismerési algoritmusok inicializálása',
		camMultipleFaces:
			'Egynél több arcot észleltek. Győződjön meg róla, hogy egyedül van a képben, majd készítsen új fényképet.',
		camNoFace:
			'Nem észleltek arcot. Győződjön meg róla, hogy arca jól látható, a kamerába néz és megfelelően megvilágított, majd próbálja újra.',
		camFaceTooSmall:
			'Az arca túl kicsinek tűnik. Közeledjen a kamerához, hogy arca több helyet foglaljon el a képben, majd készítsen új fényképet.',
		camFaceTooLarge:
			'Túl közel van a kamerához. Távolodjon el egy kicsit, hogy az egész arca beleférjen a képbe, majd készítsen új fényképet.',
		camEyesClosed: 'Úgy tűnik, a szemei behunytak. Készítsen új fényképet nyitott és jól látható szemekkel.',
		camPoseInvalid:
			'Kérem, nézzen közvetlenül a kamerába. Tartsa a fejét egyenesen—ne döntse és ne fordítsa el—és készítsen új fényképet.',
		camFaceNotCentered:
			'Arcát a kép közepére kell igazítania. Helyezkedjen úgy, hogy arca a négyzet közepén legyen, majd készítsen új fényképet.',
		camHint: 'Központosítsa az arcát és nézzen a kamerába',
		camHoldIt: 'Tartsa!',
		evaluating: 'A fénykép értékelése...',
		retryMessage:
			'A fénykép nem felel meg a követelményeinknek. Készítsen új fényképet a fenti útmutatók szerint a folytatáshoz.',
		error:
			'Hiba történt a fénykép feldolgozása során. Kérjük, próbálja újra. Ha a probléma továbbra is fennáll, ellenőrizze a kapcsolatát.',
	},
	IT: {
		title: 'Facciamo un selfie',
		back: 'Indietro',
		capture: 'Scatta foto',
		reason:
			'Dobbiamo scattare una foto per convalidare la tua identità. Questo processo è completamente automatico e la pagina successiva spiegherà cosa fare.',
		getStarted: 'Scatta un selfie',
		confirm: 'Conferma',
		retry: 'Riprova',
		takeNewPicture: 'Scatta una nuova foto',
		successMessage: 'La tua foto è corretta. Puoi continuare qui sotto.',
		camInit: 'Inizializzazione della fotocamera',
		camFaceInit: 'Inizializzazione degli algoritmi per il riconoscimento facciale',
		camMultipleFaces:
			"È stato rilevato più di un volto. Assicurati di essere solo nell'inquadratura e scatta una nuova foto.",
		camNoFace:
			'Nessun volto rilevato. Assicurati che il tuo volto sia chiaramente visibile, rivolto verso la fotocamera e ben illuminato, poi riprova.',
		camFaceTooSmall:
			"Il tuo volto sembra troppo piccolo. Avvicinati alla fotocamera per riempire meglio l'inquadratura e scatta una nuova foto.",
		camFaceTooLarge:
			"Sei troppo vicino alla fotocamera. Allontanati un po' per far entrare tutto il tuo volto nell'inquadratura e scatta una nuova foto.",
		camEyesClosed:
			'Sembra che i tuoi occhi siano chiusi. Scatta una nuova foto con gli occhi aperti e chiaramente visibili.',
		camPoseInvalid:
			'Guarda direttamente la fotocamera. Tieni la testa dritta—senza inclinarla o girarla—e scatta una nuova foto.',
		camFaceNotCentered:
			"Il tuo volto deve essere centrato nell'inquadratura. Posizionati in modo che il tuo volto sia al centro del quadrato e scatta una nuova foto.",
		camHint: 'Centra il tuo volto e guarda la fotocamera',
		camHoldIt: 'Mantieni!',
		evaluating: 'Valutazione della tua foto...',
		retryMessage:
			'La foto non soddisfa i nostri requisiti. Scatta una nuova foto seguendo le linee guida sopra per continuare.',
		error:
			"Si è verificato un errore durante l'elaborazione della tua foto. Riprova. Se il problema persiste, controlla la connessione.",
	},
	NO: {
		title: 'La oss ta et selfie',
		back: 'Tilbake',
		capture: 'Ta bilde',
		reason:
			'Vi må ta et bilde for å validere din identitet. Denne prosessen er fullstendig automatisk og neste side vil forklare hva du skal gjøre.',
		getStarted: 'Ta et selfie',
		confirm: 'Bekreft',
		retry: 'Prøv igjen',
		takeNewPicture: 'Ta et nytt bilde',
		successMessage: 'Bildet ditt ser bra ut. Du kan fortsette nedenfor.',
		camInit: 'Initialiserer kamera',
		camFaceInit: 'Initialiserer ansiktsalgoritmer',
		camMultipleFaces: 'Mer enn ett ansikt ble oppdaget. Sørg for at du er alene i bildet og ta et nytt bilde.',
		camNoFace:
			'Ingen ansikt ble oppdaget. Sørg for at ansiktet ditt er tydelig synlig, vender mot kameraet og er godt opplyst, og prøv igjen.',
		camFaceTooSmall:
			'Ansiktet ditt virker for lite. Flytt deg nærmere kameraet slik at ansiktet fyller mer av bildet, og ta et nytt bilde.',
		camFaceTooLarge:
			'Du er for nær kameraet. Gå litt bakover slik at hele ansiktet ditt får plass i bildet, og ta et nytt bilde.',
		camEyesClosed: 'Det ser ut til at øynene dine er lukket. Ta et nytt bilde med åpne og tydelig synlige øyne.',
		camPoseInvalid: 'Se rett i kameraet. Hold hodet rett—uten å vippe eller vende det—og ta et nytt bilde.',
		camFaceNotCentered:
			'Ansiktet ditt må være sentrert i bildet. Posisjoner deg slik at ansiktet er midt i kvadratet, og ta et nytt bilde.',
		camHint: 'Sentrer ansiktet ditt og se inn i kameraet',
		camHoldIt: 'Hold det!',
		evaluating: 'Evaluerer bildet ditt...',
		retryMessage:
			'Bildet oppfyller ikke våre krav. Ta et nytt bilde i henhold til retningslinjene over for å fortsette.',
		error:
			'Det oppstod en feil under behandling av bildet ditt. Vennligst prøv igjen. Hvis problemet vedvarer, sjekk tilkoblingen din.',
	},
	PT: {
		title: 'Vamos fazer uma selfie',
		back: 'Voltar',
		capture: 'Tirar foto',
		reason:
			'Precisamos tirar uma foto para validar sua identidade. Este processo é totalmente automático e a próxima página explicará o que fazer.',
		getStarted: 'Tirar uma selfie',
		confirm: 'Confirmar',
		retry: 'Tentar novamente',
		takeNewPicture: 'Tirar nova foto',
		successMessage: 'Sua foto está boa. Você pode continuar abaixo.',
		camInit: 'Inicializando câmera',
		camFaceInit: 'Inicializando algoritmos faciais',
		camMultipleFaces:
			'Mais de um rosto foi detectado. Certifique-se de estar sozinho no enquadramento e tire uma nova foto.',
		camNoFace:
			'Nenhum rosto foi detectado. Certifique-se de que seu rosto esteja claramente visível, voltado para a câmera e bem iluminado, e tente novamente.',
		camFaceTooSmall:
			'Seu rosto parece muito pequeno. Aproxime-se da câmera para que seu rosto preencha mais o enquadramento e tire uma nova foto.',
		camFaceTooLarge:
			'Você está muito perto da câmera. Afaste-se um pouco para que todo o seu rosto caiba no enquadramento e tire uma nova foto.',
		camEyesClosed:
			'Parece que seus olhos estão fechados. Tire uma nova foto com os olhos abertos e claramente visíveis.',
		camPoseInvalid:
			'Olhe diretamente para a câmera. Mantenha a cabeça reta—sem inclinar ou girar—e tire uma nova foto.',
		camFaceNotCentered:
			'Seu rosto precisa estar centralizado no enquadramento. Posicione-se para que seu rosto esteja no centro do quadrado e tire uma nova foto.',
		camHint: 'Centralize seu rosto e olhe para a câmera',
		camHoldIt: 'Segure!',
		evaluating: 'Avaliando sua foto...',
		retryMessage:
			'A foto não atende aos nossos requisitos. Tire uma nova foto seguindo as orientações acima para continuar.',
		error:
			'Ocorreu um erro ao processar sua foto. Por favor, tente novamente. Se o problema persistir, verifique sua conexão.',
	},
	RO: {
		title: 'Să facem un selfie',
		back: 'Înapoi',
		capture: 'Faceți o poză',
		reason:
			'Trebuie să facem o poză pentru a valida identitatea dvs. Acest proces este complet automat și următoarea pagină va explica ce trebuie să faceți.',
		getStarted: 'Fă un selfie',
		confirm: 'Confirmă',
		retry: 'Reîncearcă',
		takeNewPicture: 'Faceți o poză nouă',
		successMessage: 'Fotografia dvs. arată bine. Puteți continua mai jos.',
		camInit: 'Inițializare cameră',
		camFaceInit: 'Inițializare algoritmi de recunoaștere facială',
		camMultipleFaces:
			'A fost detectată mai mult de o față. Asigurați-vă că sunteți singur în cadru și faceți o poză nouă.',
		camNoFace:
			'Nu a fost detectată nicio față. Asigurați-vă că fața dvs. este clar vizibilă, îndreptată spre cameră și bine iluminată, apoi încercați din nou.',
		camFaceTooSmall:
			'Fața dvs. pare prea mică. Aproximați-vă de cameră pentru a umple mai mult cadrul și faceți o poză nouă.',
		camFaceTooLarge:
			'Sunteți prea aproape de cameră. Depărtați-vă puțin pentru ca toată fața să încapă în cadru și faceți o poză nouă.',
		camEyesClosed: 'Se pare că aveți ochii închiși. Faceți o poză nouă cu ochii deschiși și clar vizibili.',
		camPoseInvalid:
			'Vă rugăm să priviți direct în cameră. Țineți capul drept—fără să-l înclinați sau întoarceți—și faceți o poză nouă.',
		camFaceNotCentered:
			'Fața dvs. trebuie centrată în cadru. Poziționați-vă astfel încât fața să fie în mijlocul pătratului și faceți o poză nouă.',
		camHint: 'Centrați-vă fața și priviți în cameră',
		camHoldIt: 'Țineți-o!',
		evaluating: 'Evaluarea fotografiei...',
		retryMessage:
			'Fotografia nu îndeplinește cerințele noastre. Faceți o poză nouă conform ghidurilor de mai sus pentru a continua.',
		error:
			'A apărut o eroare la procesarea fotografiei. Vă rugăm să încercați din nou. Dacă problema persistă, verificați conexiunea.',
	},
	RU: {
		title: 'Давайте сделаем селфи',
		back: 'Назад',
		capture: 'Сделать фото',
		reason:
			'Нам нужно сделать фото для подтверждения вашей личности. Этот процесс полностью автоматический, и на следующей странице будет объяснено, что делать.',
		getStarted: 'Сделать селфи',
		confirm: 'Подтвердить',
		retry: 'Повторить',
		takeNewPicture: 'Сделать новое фото',
		successMessage: 'Ваше фото выглядит хорошо. Вы можете продолжить ниже.',
		camInit: 'Инициализация камеры',
		camFaceInit: 'Инициализация алгоритмов распознавания лиц',
		camMultipleFaces: 'Обнаружено более одного лица. Убедитесь, что вы один в кадре, и сделайте новое фото.',
		camNoFace:
			'Лицо не обнаружено. Убедитесь, что лицо чётко видно, обращено к камере и хорошо освещено, затем попробуйте снова.',
		camFaceTooSmall:
			'Ваше лицо кажется слишком маленьким. Подойдите ближе к камере, чтобы лицо занимало больше кадра, и сделайте новое фото.',
		camFaceTooLarge:
			'Вы слишком близко к камере. Отойдите немного, чтобы всё лицо поместилось в кадр, и сделайте новое фото.',
		camEyesClosed: 'Похоже, ваши глаза закрыты. Сделайте новое фото с открытыми и чётко видными глазами.',
		camPoseInvalid:
			'Пожалуйста, смотрите прямо в камеру. Держите голову прямо—не наклоняйте и не поворачивайте—и сделайте новое фото.',
		camFaceNotCentered:
			'Ваше лицо должно быть расположено в центре кадра. Встаньте так, чтобы лицо было в середине квадрата, и сделайте новое фото.',
		camHint: 'Отцентруйте лицо и смотрите в камеру',
		camHoldIt: 'Держите!',
		evaluating: 'Оценка вашего фото...',
		retryMessage: 'Фото не соответствует нашим требованиям. Сделайте новое фото по инструкциям выше, чтобы продолжить.',
		error: 'Произошла ошибка при обработке фото. Попробуйте снова. Если проблема сохраняется, проверьте соединение.',
	},
	SK: {
		title: 'Urobme si selfie',
		back: 'Späť',
		capture: 'Urobiť fotografiu',
		reason:
			'Musíme vyfotiť fotografiu na overenie vašej identity. Tento proces je plne automatický a na ďalšej stránke sa dozviete, čo máte robiť.',
		getStarted: 'Urobiť selfie',
		confirm: 'Potvrdiť',
		retry: 'Skúsiť znovu',
		takeNewPicture: 'Urobiť novú fotografiu',
		successMessage: 'Vaša fotografia vyzerá dobre. Môžete pokračovať nižšie.',
		camInit: 'Inicializácia kamery',
		camFaceInit: 'Inicializácia algoritmov na rozpoznávanie tvárí',
		camMultipleFaces: 'Bola zistená viac ako jedna tvár. Uistite sa, že ste sám v zábere, a urobte novú fotografiu.',
		camNoFace:
			'Nebola zistená žiadna tvár. Uistite sa, že vaša tvár je jasne viditeľná, otočená ku kamere a dobre osvetlená, potom skúste znova.',
		camFaceTooSmall:
			'Vaša tvár vyzerá príliš malá. Pristúpte bližšie ku kamere, aby vaša tvár vyplnila viac záberu, a urobte novú fotografiu.',
		camFaceTooLarge:
			'Ste príliš blízko kamery. Ustúpte trochu, aby sa celá vaša tvár zmestila do záberu, a urobte novú fotografiu.',
		camEyesClosed: 'Zdá sa, že máte zatvorené oči. Urobte novú fotografiu s otvorenými a jasne viditeľnými očami.',
		camPoseInvalid:
			'Pozrite sa priamo do kamery. Držte hlavu rovno—neklaňte ju ani neotáčajte—a urobte novú fotografiu.',
		camFaceNotCentered:
			'Vaša tvár musí byť v zábere vycentrovaná. Umiestnite sa tak, aby vaša tvár bola v strede štvorca, a urobte novú fotografiu.',
		camHint: 'Vystredte svoju tvár a pozrite do kamery',
		camHoldIt: 'Držte to!',
		evaluating: 'Vyhodnocovanie fotografie...',
		retryMessage:
			'Fotografia nespĺňa naše požiadavky. Urobte novú fotografiu podľa vyššie uvedených pokynov pre pokračovanie.',
		error:
			'Pri spracovaní vašej fotografie došlo k chybe. Skúste to prosím znova. Ak problém pretrváva, skontrolujte svoje pripojenie.',
	},
	SI: {
		title: 'Naredimo selfie',
		back: 'Nazaj',
		capture: 'Naredi fotografijo',
		reason:
			'Moramo narediti fotografijo za potrditev vaše identitete. Ta proces je popolnoma avtomatski in naslednja stran bo razložila, kaj storiti.',
		getStarted: 'Naredi selfie',
		confirm: 'Potrdi',
		retry: 'Poskusi ponovno',
		takeNewPicture: 'Naredi novo fotografijo',
		successMessage: 'Vaša fotografija izgleda dobro. Lahko nadaljujete spodaj.',
		camInit: 'Inicializiranje kamere',
		camFaceInit: 'Inicializiranje algoritmov za prepoznavanje obraza',
		camMultipleFaces: 'Opaženo je bilo več kot en obraz. Preverite, da ste sami v kadru, in naredite novo fotografijo.',
		camNoFace:
			'Obraz ni bil zaznan. Preverite, da je vaš obraz jasno viden, obrnjen proti kameri in dobro osvetljen, nato poskusite znova.',
		camFaceTooSmall:
			'Vaš obraz je preveč majhen. Približajte se kameri, da bo vaš obraz zapolnil več kadra, in naredite novo fotografijo.',
		camFaceTooLarge:
			'Preblizu ste kameri. Pomaknite se nekoliko nazaj, da se celoten obraz prilega v kadr, in naredite novo fotografijo.',
		camEyesClosed: 'Zdi se, da imate zaprte oči. Naredite novo fotografijo z odprtimi in jasno vidnimi očmi.',
		camPoseInvalid:
			'Prosim, glejte neposredno v kamero. Držite glavo pokonci—brez nagiba ali obračanja—in naredite novo fotografijo.',
		camFaceNotCentered:
			'Vaš obraz mora biti centriran v kadru. Postavite se tako, da je vaš obraz na sredini kvadrata, in naredite novo fotografijo.',
		camHint: 'Usredotočite svoj obraz in pogledajte v kamero',
		camHoldIt: 'Drži!',
		evaluating: 'Ovrednotenje fotografije...',
		retryMessage:
			'Fotografija ne izpolnjuje naših zahtev. Naredite novo fotografijo v skladu z zgornjimi smernicami za nadaljevanje.',
		error:
			'Pri obdelavi vaše fotografije je prišlo do napake. Prosimo, poskusite znova. Če težava ostane, preverite povezavo.',
	},
	SV: {
		title: 'Låt oss ta en selfie',
		back: 'Tillbaka',
		capture: 'Ta foto',
		reason:
			'Vi måste ta en bild för att validera din identitet. Denna process är helt automatisk och nästa sida kommer att förklara vad du ska göra.',
		getStarted: 'Ta en selfie',
		confirm: 'Bekräfta',
		retry: 'Försök igen',
		takeNewPicture: 'Ta en ny bild',
		successMessage: 'Din bild ser bra ut. Du kan fortsätta nedan.',
		camInit: 'Initierar kamera',
		camFaceInit: 'Initierar ansiktsalgoritmer',
		camMultipleFaces: 'Fler än ett ansikte upptäcktes. Se till att du är ensam i bilden och ta en ny bild.',
		camNoFace:
			'Inget ansikte upptäcktes. Se till att ditt ansikte är tydligt synligt, vänt mot kameran och väl belyst, och försök igen.',
		camFaceTooSmall:
			'Ditt ansikte verkar för litet. Flytta dig närmare kameran så att ansiktet fyller mer av bilden och ta en ny bild.',
		camFaceTooLarge:
			'Du är för nära kameran. Gå tillbaka lite så att hela ansiktet får plats i bilden och ta en ny bild.',
		camEyesClosed: 'Det verkar som att dina ögon är slutna. Ta en ny bild med öppna och tydligt synliga ögon.',
		camPoseInvalid: 'Titta direkt in i kameran. Håll huvudet rakt—utan att luta eller vrida det—och ta en ny bild.',
		camFaceNotCentered:
			'Ditt ansikte måste vara centrerat i bilden. Positionera dig så att ansiktet är i mitten av rutorna och ta en ny bild.',
		camHint: 'Centrera ditt ansikte och titta in i kameran',
		camHoldIt: 'Håll det!',
		evaluating: 'Utvärderar din bild...',
		retryMessage: 'Bilden uppfyller inte våra krav. Ta en ny bild enligt riktlinjerna ovan för att fortsätta.',
		error:
			'Ett fel uppstod vid behandling av din bild. Vänligen försök igen. Om problemet kvarstår, kontrollera din anslutning.',
	},
	TR: {
		title: 'Bir selfie çekelim',
		back: 'Geri',
		capture: 'Fotoğraf çek',
		reason:
			'Kimliğinizi doğrulamak için bir fotoğraf çekmemiz gerekiyor. Bu süreç tamamen otomatiktir ve bir sonraki sayfa ne yapacağınızı açıklayacaktır.',
		getStarted: 'Selfie çek',
		confirm: 'Onayla',
		retry: 'Tekrar dene',
		takeNewPicture: 'Yeni fotoğraf çek',
		successMessage: 'Fotoğrafınız iyi görünüyor. Aşağıdan devam edebilirsiniz.',
		camInit: 'Kamera başlatılıyor',
		camFaceInit: 'Yüz algoritmaları başlatılıyor',
		camMultipleFaces:
			'Birden fazla yüz tespit edildi. Kadrede yalnız olduğunuzdan emin olun ve yeni bir fotoğraf çekin.',
		camNoFace:
			'Hiçbir yüz tespit edilmedi. Yüzünüzün net göründüğünden, kameraya baktığından ve iyi aydınlatıldığından emin olun, ardından tekrar deneyin.',
		camFaceTooSmall:
			'Yüzünüz çok küçük görünüyor. Yüzünüzün kadreyi daha fazla doldurması için kameraya yaklaşın ve yeni bir fotoğraf çekin.',
		camFaceTooLarge:
			'Kameraya çok yakınsınız. Tüm yüzünüzün kadre sığması için biraz geri çekilin ve yeni bir fotoğraf çekin.',
		camEyesClosed: 'Gözleriniz kapalı görünüyor. Gözleriniz açık ve net görünür şekilde yeni bir fotoğraf çekin.',
		camPoseInvalid:
			'Lütfen doğrudan kameraya bakın. Başınızı düz tutun—eğmeyin veya çevirmeyin—ve yeni bir fotoğraf çekin.',
		camFaceNotCentered:
			'Yüzünüz kadrede ortalanmalıdır. Yüzünüz karenin ortasında olacak şekilde konumlanın ve yeni bir fotoğraf çekin.',
		camHint: 'Yüzünüzü ortada konumlandırın ve kameraya bakın',
		camHoldIt: 'Tutun!',
		evaluating: 'Fotoğrafınız değerlendiriliyor...',
		retryMessage:
			'Fotoğraf gereksinimlerimizi karşılamıyor. Devam etmek için lütfen yukarıdaki yönergelere uygun yeni bir fotoğraf çekin.',
		error:
			'Fotoğrafınız işlenirken bir hata oluştu. Lütfen tekrar deneyin. Sorun devam ederse bağlantınızı kontrol edin.',
	},
	UK: {
		title: 'Давайте зробимо селфі',
		back: 'Назад',
		capture: 'Зробити фото',
		reason:
			'Нам потрібно зробити фото для підтвердження вашої особи. Цей процес повністю автоматичний, і наступна сторінка пояснить, що робити.',
		getStarted: 'Зробити селфі',
		confirm: 'Підтвердити',
		retry: 'Повторити',
		takeNewPicture: 'Зробити нове фото',
		successMessage: 'Ваше фото виглядає добре. Ви можете продовжити нижче.',
		camInit: 'Ініціалізація камери',
		camFaceInit: 'Ініціалізація алгоритмів розпізнавання облич',
		camMultipleFaces: 'Виявлено більше одного обличчя. Переконайтеся, що ви один у кадрі, і зробіть нове фото.',
		camNoFace:
			'Обличчя не виявлено. Переконайтеся, що ваше обличчя чітко видно, звернене до камери та добре освітлене, потім спробуйте знову.',
		camFaceTooSmall:
			'Ваше обличчя здається занадто малим. Підійдіть ближче до камери, щоб обличчя займало більше кадру, і зробіть нове фото.',
		camFaceTooLarge:
			'Ви надто близько до камери. Відійдіть трохи, щоб усе обличчя поміщалося в кадр, і зробіть нове фото.',
		camEyesClosed: 'Схоже, ваші очі закриті. Зробіть нове фото з відкритими та чітко видимими очима.',
		camPoseInvalid:
			'Будь ласка, дивіться прямо в камеру. Тримайте голову рівно—не нахиляйте та не повертайте—і зробіть нове фото.',
		camFaceNotCentered:
			'Ваше обличчя має бути в центрі кадру. Розташуйтесь так, щоб обличчя було в середині квадрата, і зробіть нове фото.',
		camHint: 'Відцентруйте обличчя і дивіться в камеру',
		camHoldIt: 'Тримайте!',
		evaluating: 'Оцінка вашого фото...',
		retryMessage: 'Фото не відповідає нашим вимогам. Зробіть нове фото згідно з інструкціями вище, щоб продовжити.',
		error:
			'Під час обробки фото сталася помилка. Будь ласка, спробуйте ще раз. Якщо проблема триває, перевірте з’єднання.',
	},
};

export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults['EN'];
}

export function getLanguages() {
	return Object.keys(textDefaults);
}
